import classnames from 'classnames/bind'

// Libs

// Components
import Invite from './components/Invite'
import Connect from './components/Connect'

// Types
import { MicOnItemType, HandUpItemType } from '@/types/room'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface HandUpListProps {
  className?: string
  handUpList: HandUpItemType[]
  micOnList: MicOnItemType[]
  canHandUp: boolean
  participantList: any[]
}

const HandUpList = (props: HandUpListProps) => {
  const { className, handUpList, micOnList, canHandUp, participantList } = props

  return (
    <div className={cx('handUpList', className)}>
      {!canHandUp && <Invite />}

      {canHandUp && <Connect handUpList={handUpList} micOnList={micOnList} participantList={participantList} />}
    </div>
  )
}

export default HandUpList
